import React from 'react';

export const AboutMe = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <img src="Gf5p4lAXkAA0VmL.jpg" alt="Anjan" style={{ width: '150px', borderRadius: '50%' }} />
      <h1>About Me</h1>
      <p>Greetings, I am Anjan. I love music, movies, and video games.</p>
    </div>
  );
};